<template>
  <div>
    		<van-image width="100%" fit="cover" :src="require('../../assets/image/deatop.jpg')" />
<!--    <van-image class="q_join_bg" width="100%" fit="cover" :src="convertImg(item.url)"/>-->
    <div class="q_pad_lr15px" style="margin-bottom: 36vw;">
      <div class="q_mar_join">
<!--        <van-button plain round type="warning" size="mini" class="q_join_btn" @click="goToMember()"-->
<!--                    v-if="userDept!=undefined&&userDept.state == '1'&&costFlag"-->
<!--        >队费缴纳-->
<!--        </van-button>-->
        <div class="q_vertical_left q_mar_b15px">
          <div class="q_inlineblock q_po_re" style="font-size:0;">
            <van-image class="q_join_img" fit="cover" :src="convertImg(join.pic)"/>
            <span v-if="userDept!=null&&userDept.state=='1'&&costFlag&&nowCostFlag"
                  class="q_join_date">{{ parseTime(userDept.expirationTime) }}到期</span>
          </div>
          <div class="q_mar_l15px q_inlineblock q_con">
            <div class="q_text_m q_bold q_moit3 q_justify">{{ join.deptName }}</div>
            <!-- <div class="q_text_s q_color_gray q_mar_t5px">{{ join.address }}</div> -->
            <div class="q_vertical_left q_mar_t30px q_borra">
              <van-image v-for="user in join.userList" width="5vw" height="5vw" fit="cover"
                         :src="user.avatar" style="margin-right: 1vw;"/>
              <span class="q_text_s q_color_gray"
                    v-if="join.userList!=null&&join.userList.length>0">等{{ join.deptUserNumber }}位伙伴</span>
            </div>
          </div>
        </div>
      </div>
      <van-tabs v-model="joinactive" @click="onClick" swipe-threshold="4">
        <van-tab title="中队简介" name="1">
          <div class="q_vertical_left q_acti q_mar_t15px" style="width: 100%;">
            <img src="@/assets/image/address.png"/>
            <span class="q_text_m q_mar_l10px">{{ join.address }}</span>
          </div>
          <div class="q_vertical_left q_acti q_mar_t15px" style="width: 100%;">
            <div class="q_vertical_left q_borra">
              <van-image v-for="user in join.userList" width="5vw" height="5vw" fit="cover"
                         :src="user.avatar" style="margin-right: 1vw;"/>
              <span class="q_text_m q_mar_l10px"
                    v-if="join.userList!=null&&join.userList.length>0">共{{ join.deptUserNumber }}名成员</span>
            </div>
          </div>
          <div class="q_artdea q_mar_t15px">
            <div class="ql-editor" v-html="join.content"></div>
            <!--						<p><img src="../../assets/image/act.png" /></p>-->
          </div>
          <!--          <van-button v-if="userDept!=undefined&&userDept.state=='1'" type="primary" round style="margin-top: 100%;margin-left: 40%" size="small" color="#FF5733" @click="exitShow = true">退出中队</van-button>-->
          <!--          <van-goods-action-button type="primary" style="margin-top: 90%" color="#FF5733" text="退出中队" @click="showPopup"/>-->
        </van-tab>


        <!--        组织架构-->
        <van-tab title="组织架构" name="5">
          <div v-for="item in this.join.organizationList">
            <van-image class="q_org_img" fit="cover" :src="item"/>
          </div>
        </van-tab>
        <!-- ---------------------------------------------活动列表 ----------------------------------------------------- -->

        <van-tab title="志愿活动" name="2">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功" v-if="!showEmpty">
            <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了"
                      @load="activityOnLoad" error-text="请求失败，点击重新加载">
              <div class="q_mar_t15px">
                <div class="q_lame" v-for="item in activity" @click="goToActivdea(item.id)">
                  <van-image fit="cover" :src="item.banner"/>
                  <div class="q_text_m q_bold q_mar_t10px q_moit1 q_justify">{{ item.name }}</div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
          <!--空数据-->
          <div class="q_center" style="margin-top: 10vh;margin-bottom: 10vh;" v-if="showEmpty">
            <img src="@/assets/image/none.png" style="width: 26vw;"/>
            <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
          </div>
        </van-tab>


        <!-- ---------------------------------------------活动列表end ----------------------------------------------------- -->

        <!-- ---------------------------------------------动态列表 --------------------------------------------------------- -->

        <!--        <van-tab title="中队资讯" name="3">-->
        <!--          <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功" v-if="!showEmpty">-->
        <!--            <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了"-->
        <!--                      @load="articleOnLoad" error-text="请求失败，点击重新加载">-->
        <!--              <div class="q_vertical_left q_mar_t15px" style="width: 100%" v-for="item in article"-->
        <!--                   @click="goToArtdea(item.id)">-->
        <!--                <div class="q_inlineblock">-->
        <!--                  <van-image class="q_act_img" fit="cover" :src="item.pic"/>-->
        <!--                </div>-->
        <!--                <div class="q_mar_l15px q_inlineblock">-->
        <!--                  <div class="q_text_m q_bold q_moit2 q_justify">{{ item.name }}</div>-->
        <!--                  <div class="q_text_s q_color_gray q_mar_t10px">{{ item.publishTime }}</div>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </van-list>-->

        <!--          </van-pull-refresh>-->
        <!--          &lt;!&ndash;空数据&ndash;&gt;-->
        <!--          <div class="q_center" style="margin-top: 10vh;margin-bottom: 10vh;" v-if="showEmpty">-->
        <!--            <img src="@/assets/image/none.png" style="width: 26vw;"/>-->
        <!--            <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>-->
        <!--          </div>-->
        <!--        </van-tab>-->

        <!-- ---------------------------------------------动态列表end ----------------------------------------------------- -->

        <van-tab title="中队募捐" name="4">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功" v-if="!showEmpty">
            <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了"
                      @load="articleOnLoad" error-text="请求失败，点击重新加载">

              <div class="q_vertical_left q_mar_t15px" style="width: 100%" v-for="item in donation"
                   @click="goToSpeeddea(item.id)">
                <div class="q_inlineblock q_po_re">
                  <span v-if="item.state == '1'" class="q_speed_type">已停止</span>
                  <span v-if="item.state == '2'" class="q_speed_type">已结束</span>
                  <van-image class="q_speed_img" fit="cover"
                             :src="item.pic"/>
                </div>
                <div class="q_mar_l15px q_inlineblock" style="width: 100%;">
                  <div class="q_text_m q_bold q_moit2 q_justify">{{ item.ittle }}</div>
                  <div class="q_mar_t20px">
                    <div class="q_speed q_inlineblock q_veralign_middle" style="width: 60%;">
                      <span class="q_text_s q_color_gray">{{ item.percentage }}%</span>
                      <span class="q_text_s q_color_gray q_flo_right">{{ item.sumMoney }}元</span>
                      <div class="q_speed_b">
                        <div :style="{width: item.percentage + '%'}" class="q_speed_t"></div>
                      </div>
                    </div>
                    <!-- 日期年月日即可，不用到时分秒。搁不哈 -->
                    <div class="q_text_s q_color_gray q_inlineblock q_veralign_middle q_right"
                         style="width: 40%;">{{ item.createTime }}
                    </div>
                  </div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
          <!--空数据-->
          <div class="q_center" style="margin-top: 10vh;margin-bottom: 10vh;" v-if="showEmpty">
            <img src="@/assets/image/none.png" style="width: 26vw;"/>
            <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <!-- 未加入时显示 -->
    <van-goods-action v-if="userDept==undefined||userDept.state=='2'">
      <van-goods-action-button type="danger" color="#FF5733" text="申请加入" @click="showPopup"/>
    </van-goods-action>
    <van-goods-action v-if="userDept!=undefined&&userDept.state=='0'">
      <span class="q_color_gray q_text_m" style="margin: 0 auto">正在审核</span>
    </van-goods-action>
    <van-popup class="q_bor_5" v-model="show" style="width: 70%;">
      <div class="q_center">
        <p class="q_text_m q_bold q_pad_15px q_pad_t30px">基础资料是否已确认无误？</p>
        <!-- 资料已完善跳转基础资料展示页(Basicd.vue)，资料未完善跳转资料填写页(Basicdata.vue) -->
        <p class="q_text_s q_color_gray q_bor_bottom q_pad_b20px" @click="goToBasicd()">去看看</p>
        <div>
          <span class="q_pad_tb15px q_inlineblock" style="width: 50%;" @click="show=false">取 消</span>
          <span class="q_pad_tb15px q_inlineblock q_color_default" style="width: 50%;"
                @click="goToFeedback()">确 认</span>
        </div>
      </div>
    </van-popup>
    <!-- 退出中队时显示 -->
    <van-goods-action v-if="userDept!=undefined&&userDept.state=='1'">
      <!-- <van-goods-action-button type="danger" color="#FF5733" text="退出中队" @click="exitShow = true"/> -->
      <van-goods-action-icon icon="flag-o" text="退出中队" @click="exitShow = true" style="margin-left: 3vw;"/>
    </van-goods-action>
    <van-popup class="q_bor_5" v-model="exitShow" style="width: 70%;">
      <div class="q_center">
        <p class="q_text_m q_bold q_pad_15px q_pad_t30px">确定退出中队？</p>
        <div>
          <span class="q_pad_tb15px q_inlineblock" style="width: 50%;" @click="exitShow=false">取 消</span>
          <span class="q_pad_tb15px q_inlineblock q_color_default" style="width: 50%;" @click="exitJoin()">确
						认</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {getJoinById} from "@/api/join";
import {listActivity} from "@/api/activity";
import {listArticle} from "@/api/article";
import {addUserDept, delUserDept, getUserDeptByUserIdAndDeptId} from "@/api/userDept";
import {getLoginUser} from "@/api/login";
import {listDonation} from "@/api/donation";
import {convertImg, parseTime, wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Joindea',
  props: {
    msg: String
  },
  data() {
    return {
      //今天没到期
      nowCostFlag: true,
      //会费到期显示
      costFlag: true,
      pathList: [],
      exitShow: false,
      showEmpty: false,
      refreshing: false,
      loading: false,
      finished: false,
      joinactive: 0,
      show: false,
      join: {},
      joinId: '',
      pageParam: {
        pageNum: 0,
        pageSize: 6,
        deptId: ''
      },
      activity: [],
      article: [],
      donation: [],
      name: '',
      user: {},
      userDept: undefined
    }
  },
  created() {
    wxCloseShare()
    this.joinId = this.$route.query.id;
    getLoginUser().then(res => {
      this.user = res.data
    }).then(() => {
      this.init()
    })
  },
  methods: {
    convertImg,

    /**
     * 下拉刷新
     */
    onRefresh() {
      this.pageParam.pageNum = 0
      this.pageParam.pageSize = 6
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      //this.onLoad()
      if (this.name == '2') {
        this.activity = []
        this.activityOnLoad()
      }
      if (this.name == '3') {
        this.article = []
        this.articleOnLoad()
      }
      if (this.name == '4') {
        this.donation = []
        this.donationOnLoad()
      }
    },
    /**
     * 动态下滑加载更多
     */
    articleOnLoad() {
      this.pageParam.pageNum++
      if (this.pageParam.pageNum == 1) {
        this.$modal.loading()
      }
      //查询动态信息列表
      listArticle(this.pageParam).then(res => {
        if (res.total == 0) {
          this.showEmpty = true
        } else {
          this.showEmpty = false
        }
        //是否下拉刷新
        if (this.refreshing) {
          this.article = [];
          this.refreshing = false;
        }
        for (let i = 0; i < res.rows.length; i++) {
          this.article.push(res.rows[i]);
        }

        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.article.length >= res.total) {
          this.finished = true;
        }
      }).finally(() => {
        this.$modal.closeLoading()
      })
    },
    /**
     * 募捐下滑加载更多
     */
    donationOnLoad() {
      this.pageParam.pageNum++
      if (this.pageParam.pageNum == 1) {
        this.$modal.loading()
      }
      //查询募捐项目信息列表
      listDonation(this.pageParam).then(res => {
        if (res.total == 0) {
          this.showEmpty = true
        }
        //是否下拉刷新
        if (this.refreshing) {
          this.donation = [];
          this.refreshing = false;
        }
        for (let i = 0; i < res.rows.length; i++) {
          //处理创建时间
          res.rows[i].createTime = res.rows[i].createTime.substring(0, 10)
          res.rows[i].percentage = ((res.rows[i].money / res.rows[i].sumMoney) * 100).toFixed(2)
          this.donation.push(res.rows[i]);
        }

        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.donation.length >= res.total) {
          this.finished = true;
        }
      }).finally(() => {
        this.$modal.closeLoading()
      })
    },
    /**
     * 活动下滑加载更多
     */
    activityOnLoad() {
      this.pageParam.pageNum++
      if (this.pageParam.pageNum == 1) {
        this.$modal.loading()
      }
      //查询活动信息列表
      listActivity(this.pageParam).then(res => {
        if (res.total == 0) {
          this.showEmpty = true
        } else {
          this.showEmpty = false
        }
        //是否下拉刷新
        if (this.refreshing) {
          this.activity = [];
          this.refreshing = false;
        }
        for (let i = 0; i < res.rows.length; i++) {
          this.activity.push(res.rows[i]);
        }

        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.activity.length >= res.total) {
          this.finished = true;
        }
      }).finally(() => {
        this.$modal.closeLoading()
      })
    },
    onClick(name, title) {
      //每次点击清空列表，重置查询条件
      this.pageParam.pageNum = 0
      this.pageParam.pageSize = 6
      this.activity = []
      this.article = []
      this.donation = []
      if (name == '2') {
        this.name = name
        this.onRefresh()
      }
      if (name == '3') {
        this.name = name
        this.onRefresh()
      }
      if (name == '4') {
        this.name = name
        this.onRefresh()
      }
    },
    /**
     * 初始化
     */
    init() {
      this.$modal.loading()
      //获取中队详情信息
      getJoinById(this.joinId).then((res) => {
        this.pageParam.deptId = res.data.deptId
        this.join = res.data
        const sliceA = res.data.userList.slice(0, 3)
        this.join.userList = sliceA
      }).then(() => {
        //查询中队与用户关系
        getUserDeptByUserIdAndDeptId(this.user.id, this.joinId).then(res => {
          this.userDept = res.data
          if (res.data != null && res.data.expirationTime != null) {
            if ((new Date().getFullYear() + 10) < (parseInt(res.data.expirationTime.substring(0, 4)))) {
              this.costFlag = false
            }
            //当前时间大于过期时间，不显示
            if (new Date() > new Date(res.data.expirationTime)) {
              this.nowCostFlag = false
            }
          }
        })
      }).finally(() => {
        this.$modal.closeLoading()
      })
    },

    goToArtdea(id) {
      this.$router.push({
        path: '/home/Artdea',
        query: {
          id: id
        }
      });
    },
    goToActivdea(id) {
      this.$router.push({
        path: '/activity/Activdea/',
        query: {
          id: id
        }
      });
    },
    goToMember() {
      this.$router.push({
        path: '/mine/Member/',
        query: {
          id: this.joinId
        }
      });
    },
    showPopup() {
      if (this.user.baseAudit == null) {
        return this.$modal.alert("请先完善基本信息");
      }
      if (this.user.baseAudit.auditState == '1') {
        this.show = true;
      } else {
        return this.$modal.alert("已完善信息，请耐心等待审核");
      }
    },
    /**
     * 退出中队
     */
    exitJoin() {
      this.exitShow = false
      this.$modal.loading("正在退出中队")
      delUserDept(this.userDept.id).then(res => {
        this.$modal.success("退出成功")
        //定时1.5秒跳回首页
        setTimeout(() => {
          this.$modal.closeLoading()
          //返回上一页
          window.history.go(-1)
        }, 1500);
      }).catch(() => {
        this.buttonLoading = false
        this.$modal.closeLoading()
      })
    },
    /**
     * 确认提交申请
     */
    goToFeedback() {
      this.show = false
      this.$modal.loading("正在提交申请")
      var params = {
        userId: this.user.id,
        deptId: this.join.deptId
      }
      //添加用户申请
      addUserDept(params).then(res => {
        this.$modal.success("提交成功")
        setTimeout(() => {
          this.buttonLoading = false
          this.$modal.closeLoading()
          location.reload()
        }, 1500);
      }).catch(() => {
        this.buttonLoading = false
        this.$modal.closeLoading()
      })
    },
    goToBasicd() {
      this.$router.push({
        path: '/mine/Basicd'
      });
    },
    goToSpeeddea(id) {
      this.$router.push({
        path: '/home/Speeddea', query: {id: id}
      });
    },
    parseTime(date) {
      return parseTime(date, '{y}-{m}-{d}')
    }
  },
}
</script>
<style scoped="scoped">
.q_lame {
  display: inline-block;
  width: 50%;
}

.q_lame:nth-child(2n-1) {
  padding-right: 7px;
}

.q_lame:nth-child(2n) {
  padding-left: 7px;
}

.q_lame >>> .van-image {
  width: 165.5px;
  height: 93px;
}

.q_lame >>> .van-image .van-image__img {
  border-radius: 5px;
}

.q_join_img {
  width: 105px;
  height: 105px;
}

.q_join_img >>> .van-image__img {
  border-radius: 5px;
}

.q_borra >>> .van-image__img {
  border-radius: 50%;
}

.q_con {
  width: 140px;
}

.q_mar_join {
  background-color: #ffffff;
  position: absolute;
  top: 60px;
  width: 345px;
  border-radius: 5px;
  padding: 15px;
}

.van-tabs {
  top: 60px;
}

.q_acti img {
  height: 14px;
}

>>> .van-goods-action-button--last {
  margin-right: 80px;
}

.van-goods-action-button--first {
  margin-left: 80px;
}

.van-goods-action {
  box-shadow: 0 0 10px #f2f3f7;
  height: 60px;
}

>>> .van-tab--active {
  font-weight: 700;
  font-size: 16px;
}

>>> .van-tabs__line {
  background-color: #FF5733;
  height: 6px;
  border-radius: 3px;
  width: 30px;
}

.q_join_bg >>> .van-image__img {
  height: 130px;
}

.q_act_img {
  width: 110px;
  height: 62px !important;
}

.q_speed_img {
  width: 110px;
  height: 110px;
}

.q_act_img >>> .van-image__img,
.q_speed_img >>> .van-image__img {
  border-radius: 5px;
}

.q_org_img {
  max-width: 100%;
  margin-top: 10px;
}

.q_speed_b {
  background-color: #F2F3F7;
  width: 100%;
  height: 6px;
  border-radius: 3px;
  position: relative;
}

.q_speed_t {
  background-color: #FF5733;
  width: 10%;
  height: 6px;
  border-radius: 3px;
  position: absolute;
  top: 0px;
  left: 0;
}

.q_join_btn {
  position: absolute;
  right: 15px;
  top: 15px;
}

.q_join_date {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: inline-block;
  background-color: rgba(0, 0, 0, .6);
  color: #ffffff;
  font-size: 12px;
  text-align: center;
}
</style>
